import { Link } from 'react-router-dom';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import dayjs from 'dayjs';
import "./Invoice.scss"

const header_table = [
    '№',
    'Наименование работ, услуг',
    'Кол-во',
    'Ед.',
    'Цена',
    'Сумма',
]



// "invoiceNumber": "7",
// "amount": 100,
// "currency": "RUB",
// "status": 0,
// "requisites": {
//     "company_name": "ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ \"ЕКОМСЕЛЛЕР\"",
//     "inn": "9728036721",
//     "kpp": "772801001",
//     "account": "40702810810002036116",
//     "bank_name": "АО «ТБанк»",
//     "bik": "044525974",
//     "corr_account": "30101810145250000974"
// },
// "paymentPurpose": "Оплата по счёту № 7. Payment ID: e3ec865d-1481-48ca-9d13-6fde68d49bee. Без НДС.",
// "expiresAt": "2026-09-25T09:38:49+03:00"


const Invoice = ({ data }) => {

    const {
        bik,
        bank_client,
        number,
        date,
        executor,
        client,
        inn_client,
        account_client,
        kpp_client,
        initials_company_director,
        initials_accountant,

        invoiceNumber,
        amount,
        paymentPurpose,
        requisites,
        account,
        expiresAt,
        buyerRequisites,
        amountInWords
    } = data

    const body_table = [
        [
            1,
            paymentPurpose,
            1,
            'Услуга',
            amount?.toLocaleString(),
            amount?.toLocaleString()
        ],
    ]

    const reportTemplateRef = useRef(null);

    const handleGeneratePdf = async () => {
        const canvas = await html2canvas(reportTemplateRef.current)
        const imgData = canvas.toDataURL("image/png")
        const doc = new jsPDF({
            format: 'a4',
            unit: 'px',
        });

        const width = doc.internal.pageSize.getWidth()
        const height = (canvas.height * width) / canvas.width
        doc.addImage(imgData, "PNG", 0, 0, width, height)
        doc.save('document')
    };

    return (
        <div className='document-page'>
            <ButtonBasic
                onClick={handleGeneratePdf}
                green
                text='Сгенерировать PDF'
            />
            <div className='invoice' ref={reportTemplateRef}>
                <table className='invoice__table-requisites'>
                    <tbody>
                        <tr>
                            <td colSpan={2}>{requisites?.bank_name}</td>
                            <td>БИК</td>
                            <td>{requisites?.bik}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>Банк получателя</td>
                            <td>Сч. №</td>
                            <td>{requisites?.account}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>ИНН {requisites?.inn}</td>
                            <td>Корр. сч. №</td>
                            <td>{requisites?.corr_account}</td>
                        </tr>
                        <tr>
                            <td colSpan={2}>Получатель: {requisites?.company_name}</td>
                            <td>КПП </td>
                            <td>{requisites?.kpp}</td>
                        </tr>
                    </tbody>
                </table>

                <h1 className='invoice__title'>Счет на оплату № <span>{invoiceNumber}</span> от <span>{dayjs(expiresAt).format('DD.MM.YY HH:mm')}</span></h1>

                <div className='invoice__executor'>
                    <p className='invoice__placeholder'>Поставщик<br /> (Исполнитель):</p>
                    <p className='invoice__text'>{`
                    ${requisites?.company_name},
                    ИНН ${requisites?.inn},
                    КПП ${requisites?.kpp},
                    ${requisites?.address},
                    тел  ${requisites?.phone},
                `}</p>
                </div>

                <div className='invoice__executor'>
                    <p className='invoice__placeholder'>Покупатель <br />(Заказчик):</p>
                    <p className='invoice__text-bold invoice__text'>{`
                    ${buyerRequisites?.company_name},
                    ИНН ${buyerRequisites?.inn},
                    КПП ${buyerRequisites?.kpp},
                    ${buyerRequisites?.address}
 
                `}</p>
                </div>

                <div className='invoice__executor'>
                    <p className='invoice__placeholder'>Основание:</p>
                </div>

                <table className='invoice__table'>
                    <thead>
                        <tr>
                            {header_table.map((el, ind) => {
                                return <th key={el + ind}>{el}</th>
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        {body_table.map((el, ind) => {
                            return <tr key={el + ind}>
                                {el.map((el, ind) => <td key={el + ind} >{el}</td>)}
                            </tr>
                        })}
                        <tr className='tr-total'>
                            <td colSpan={4}></td>
                            <td>Итого</td>
                            <td>{amount?.toLocaleString()}</td>
                        </tr>
                        <tr className='tr-total'>
                            <td colSpan={4}></td>
                            <td>Без налога</td>
                            <td>-</td>
                        </tr>
                        <tr className='tr-total'>
                            <td colSpan={4}></td>
                            <td>Всего к оплате:</td>
                            <td>{amount?.toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>

                <p className='invoice__text-9'>
                    Всего наименований <span>1</span> на сумму <span>{amount?.toLocaleString()}</span> руб.
                </p>
                <p className='invoice__text-9 invoice__text-bold'>
                    <span>{amountInWords}</span>
                </p>

                <div className='invoice__delimetr'></div>

                <div className='invoice__place-signature-group'>
                    <div className='invoice__place-signature'>
                        <p className='invoice__text-9  invoice__text-bold'>Руководитель</p>
                        <p className='invoice__text-8 invoice__text-nowrap'>{requisites?.director}</p>
                    </div>

                    <div className='invoice__place-signature'>
                        <p className='invoice__text-9  invoice__text-bold'>Бухгалтер</p>
                        <p className='invoice__text-8 invoice__text-nowrap'>{requisites?.chief_accountant}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export { Invoice }